<div [class.placeholder-glow]="isLoading()">
        <div class="row g-4">
            @if (isLoading()) {
                @for (_ of [1,2,3]; track $index) {
                    <div class="col-12 col-md-4 text-center">
                        <div class="placeholder-skeleton-donut mx-auto mb-3"></div>
                        <div class="placeholder col-4 mb-2"></div>
                        <div class="placeholder col-6"></div>
                    </div>
                }
            } @else {
                @for (donut of donuts(); track donut.label) {
                    <div class="col-12 col-md-4">
                        <div class="text-center">
                            <div class="donut-label fw-semibold mb-2">{{ donut.label }}</div>

                            <div class="donut-wrapper mx-auto">
                                <svg viewBox="0 0 100 100" class="donut-svg">
                                    <!-- Track -->
                                    <circle cx="50" cy="50" r="45"
                                        [attr.stroke]="donut.trackColorVar"
                                        stroke-width="10"
                                        fill="none" />
                                    <!-- Fill -->
                                    @if (donut.hasBudget) {
                                        <circle cx="50" cy="50" r="45"
                                            [attr.stroke]="donut.fillColorVar"
                                            stroke-width="10"
                                            fill="none"
                                            stroke-linecap="round"
                                            [attr.stroke-dasharray]="circumference"
                                            [attr.stroke-dashoffset]="dashOffset(donut.visualPercentage)"
                                            transform="rotate(-90 50 50)" />
                                    }
                                </svg>
                                <div class="donut-center">
                                    @if (donut.hasBudget) {
                                        <div class="donut-percentage fw-bold">
                                            {{ donut.utilizationPercentage | number:'1.2-2' }}<span class="fs-6">%</span>
                                        </div>
                                        <div class="text-muted small">of budget</div>
                                    } @else {
                                        <div class="text-muted">—</div>
                                        <div class="text-muted small">no budget</div>
                                    }
                                </div>
                            </div>

                            <div class="mt-3 px-3">
                                <div class="d-flex justify-content-between small mb-1">
                                    <span class="text-muted">Actual</span>
                                    <span class="fw-bold">{{ donut.actual | CurrencyDisplay: summary()!.currency }}</span>
                                </div>
                                <div class="d-flex justify-content-between small mb-1">
                                    <span class="text-muted">Budgeted</span>
                                    <span class="fw-semibold">{{ donut.budgeted | CurrencyDisplay: summary()!.currency }}</span>
                                </div>
                                <div class="d-flex justify-content-between small">
                                    <span class="text-muted">Variance</span>
                                    <span class="fw-semibold" [class]="donut.varianceColorClass">
                                        {{ donut.variance | CurrencyDisplay: summary()!.currency }}
                                        <span class="ms-1">({{ donut.variancePercentageDisplay }})</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
</div>
